import { addLinkAssetLOTO } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
} from "@material-ui/core";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
	AssetId: number | string;
	searchAssetResources?: Function;
	setRemoveLOTOError: Function;
	TemplateName: string;
	AssetName: string;
};

export const AssetAddLOTODialog = ({
	show,
	onHide,
	AssetId,
	searchAssetResources,
	setRemoveLOTOError,
	TemplateName,
	AssetName,
}: Props) => {
	const {
		state: { templateLOTOToAdd },
	} = useTemplatesContext();

	const addResourcesToAsset = async () => {
		if (templateLOTOToAdd) {
			const res = await addLinkAssetLOTO(
				AssetId,
				templateLOTOToAdd.LOTONumber,
				templateLOTOToAdd.LOTOName,
				"",
			);
			if (res.ok) {
				if (searchAssetResources) {
					searchAssetResources();
					onHide(true);
				}
			} else {
				setRemoveLOTOError(res.message);
				onHide(false);
			}
		}
	};

	return (
		<Dialog open={show} aria-labelledby="responsive-dialog-title">
			<DialogTitle style={{ paddingBottom: 6 }} id="responsive-dialog-title">
				{`Add LOTO to Asset: ${AssetName}`}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					The following LOTO: {templateLOTOToAdd.LOTOName} have been added to
					the Template {TemplateName}. Would you like to add them to the
					corresponding asset as well?
				</DialogContentText>
			</DialogContent>
			<DialogActions style={{ padding: "24px" }}>
				<Button
					variant="contained"
					fullWidth
					color="default"
					onClick={() => onHide(false)}
				>
					SKIP
				</Button>
				<Button
					fullWidth
					variant="contained"
					onClick={addResourcesToAsset}
					color="primary"
					autoFocus
				>
					ADD
				</Button>
			</DialogActions>
		</Dialog>
	);
};
